import axios from "axios";
import store from "@/store/index";
import { setupCache } from "axios-cache-adapter";
// import msal from "vue-msal";
import notifications from "@/helpers/notification";
import { logout } from "@/helpers/logout";

import _ from "lodash";
import router from "@/router";

let loadingCount = 0;

function update() {
  if (loadingCount > 0) {
    store.dispatch("shared/isLoading", true);
  } else {
    store.dispatch("shared/isLoading", false);
  }
}

const cache = setupCache({
  // maxAge: 15 * 60 * 1000,
  maxAge: 0,
  exclude: { query: false },
});

const baseURL = process.env.VUE_APP_APIURL;

const baseApi = axios.create({
  adapter: cache.adapter,
});

baseApi.defaults.baseURL = baseURL;

baseApi.interceptors.request.use(function (config) {
  const hideLoader =
    (config && (config as any).hideLoader) ||
    (config.data && config.data.hideLoader) ||
    (config as any).headers.hideLoader;

  if (!hideLoader) {
    loadingCount = loadingCount + 1;
    update();
  }

  const tokenId = "msal." + process.env.VUE_APP_CLIENTID + ".idtoken";
  (config as any).headers.Authorization = `Bearer ${localStorage.getItem(
    tokenId
  )}`;
  (config as any).headers.pragma = "no-cache";
  (config as any).headers["cache-control"] = "no-cache";

  return config;
});
baseApi.interceptors.response.use((response) => {
  const hideLoader =
    (response?.config && (response.config as any).hideLoader) ||
    (response?.config?.data &&
      typeof response.config.data === "string" &&
      JSON.parse(response.config.data).hideLoader) ||
    (response?.config as any).headers?.hideLoader;

  if (!hideLoader) {
    loadingCount = loadingCount - 1;
    update();
  }

  return response;
});
baseApi.interceptors.response.use(null as any, function (error) {
  const vm = router.app as any;
  const hideLoader =
    error.config?.hideLoader ||
    (error.config?.data &&
      typeof error.config.data === "string" &&
      JSON.parse(error.config.data).hideLoader) ||
    (error?.config as any).headers?.hideLoader;

  if (!hideLoader) {
    loadingCount = loadingCount - 1;
    update();
  }

  if (error.response && error.response.status) {
    console.info(error.response);
    switch (error.response.status) {
      case 400: {
        const errResponse =
          error.response?.data?.errors || error?.response?.data;
        if (_.isObject(errResponse)) {
          let errorMsg = "";
          _.forOwn(errResponse, function (value) {
            errorMsg = errorMsg + "- " + value + "<br>";
          });
          notifications.warn(errorMsg);
        } else {
          notifications.warn(errResponse || "Ugyldig input");
        }

        break;
      }

      case 401:
        notifications.warn("Du er ikke logget inn");
        setTimeout(() => {
          logout();
        }, 2000);
        break;
      case 404: {
        notifications.warn("Ikke funnet");
        break;
      }
      case 415:
        notifications.warn("Ugyldig forespørsel");
        break;
      case 500: {
        const message =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Feil på server";

        notifications.error(message);

        break;
      }
    }
  } else {
    notifications.error("Ikke kontakt med server");
  }
  return Promise.reject(error);
});

export default baseApi;
